import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Home from './components/Home';
import Certification from './components/Certification';
import Services from './components/Services';
import Contact from './components/Contact';
import './App.css';

function App() {
  return (
    <Router>
    <div className="App">
        <Navigation />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            {/* <Route path="/certification" element={<Certification />} /> */}
            {/* <Route path="/services" element={<Services />} /> */}
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
    </div>
    </Router>
  );
}

export default App;
